import { render, staticRenderFns } from "./ItemPdf.vue?vue&type=template&id=f186800c&scoped=true&"
import script from "./ItemPdf.vue?vue&type=script&lang=js&"
export * from "./ItemPdf.vue?vue&type=script&lang=js&"
import style0 from "./ItemPdf.vue?vue&type=style&index=0&id=f186800c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f186800c",
  null
  
)

export default component.exports